import React, {useState} from 'react';
import {ORDER_PAGES} from "../JobOrderPage";
import {toast} from "react-toastify";
import Card from "../../components/Card";
import CreateEditOrder from "../../components/job/order/CreateEditOrder";

const JobOrderEditPage = (props) => {
    const {
        jobId           = null,
        orderId         = null,
        parentId        = "",
        onChangePage    = (INDEX, order) => {}
    } = props;

    const handleClickBack = (event) => {
        event.preventDefault();
        onChangePage(ORDER_PAGES.INDEX, {id: orderId});
    }

    const handleCancel = () => {
        onChangePage(ORDER_PAGES.INDEX, {id: orderId});
    }

    const handleComplete = (quote) => {
        if (!!orderId) {
            toast.success(<div>{"Order updated."}</div>);
        } else {
            toast.success(<div>{"Order created."}</div>);
        }

        onChangePage(ORDER_PAGES.INDEX, {id: orderId});
    }

    return (
        <React.Fragment>
            <Card
                title={!!orderId ? "Edit Order" : "Create Order"}
                classes={"mh-100 border-0"}
                controls={can('viewAny', 'order') ? (
                    <button
                        onClick={(event) => handleClickBack(event)}
                        className={"btn font-weight-bold btn-outline-eh-off-black px-4 m-0"}
                    >
                        <i className={"fa fa-chevron-left mr-2"} />
                        <span>{"Back"}</span>
                    </button>
                ) : null}
            >
                <CreateEditOrder
                    jobId={jobId}
                    orderId={orderId}
                    onCancel={() => handleCancel()}
                    onComplete={(order) => handleComplete(order)}
                    parentId={parentId}
                />
            </Card>
        </React.Fragment>
    )
}

export default JobOrderEditPage;
